import React, { useState, useEffect } from 'react'
import { Button, Image, Loader } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { getDataProfile, getPreferencesPrivacity, updatePreferencesPrivacityOfUser } from '../../redux/actions/user'
import './Privacity.scss'
import { withRouter } from 'react-router'
import { toast } from 'react-toastify'

const Privacity = props => {

    const { dataPrivacity, dataUser } = props;
    const [dataMode, setDataMode] = useState([])
    const [txtButton, setTxtButton] = useState(null)

    useEffect(() => {

        if(!dataPrivacity) {
            props.getPreferencesPrivacity();
        }
        if(!dataUser) {
            props.getDataProfile();
            
        }else {
            if(dataUser.preferences_privacity && dataUser.preferences_privacity.length > 0) {
                if(dataMode.length === 0 && dataPrivacity) {
                    let arrayData = dataPrivacity.map( dp => {
                        let prefsPriv = dataUser.preferences_privacity.filter(dtp => {
                            if(dp.id === dtp.id) {
                                return dtp
                            }
                        })
                        return {
                            ...dp,
                            preferences_privacity: prefsPriv[0]
                        }
                    })
                    setDataMode([...arrayData]);
                }
            }
        }
        
    }, [dataMode, dataPrivacity, txtButton])

    // Funcion para activar una preferencia
    const turnOnOff = id => {
        setTxtButton(null)
        let arrayDataMode = dataMode.map(dm => {
            if(dm.id === id) {
                dm.preferences_privacity.active = !dm.preferences_privacity.active
            }
            return dm;
        })
        setDataMode([...arrayDataMode]);
    }

    // Funcion para guardar las nuevas prefs de privacidad del usuario
    const handleSubmit = () => {

        let finalDataMode = getDataMode(dataMode);
        props.updatePreferencesPrivacityOfUser(finalDataMode)
        toast.success('¡Tus preferencias han sido guardadas correctamente!')

    }


    return (
        <div className='privacity'>
            <div className="privacity_content">
                <h2>PREFERENCIAS DE PRIVACIDAD</h2>
                {
                    dataPrivacity && dataMode.length > 0 ?
                    <div className="privacity_content_cards">
                        {
                            dataMode.map(dp => (
                                <div key={dp.id} className='privacity_content_cards_card'>
                                    <Image src={dp.image_url} />
                                    <h1>{dp.name.toUpperCase()}</h1>
                                    <span>{dp.about}</span>
                                    <div className='privacity_content_cards_card_button'>
                                    
                                        <Button className={dp.preferences_privacity.active === true ? 'active' : 'inactive'} onClick={() => turnOnOff(dp.id)} >
                                            {
                                                dp.preferences_privacity.active === true ? 
                                                'Bloqueando' : 
                                                'No bloqueando'
                                            }
                                        </Button>
                                    </div>
                                </div>
                            ))
                        }
                    </div> :
                    <Loader active={true}>Cargando información...</Loader>
                }
                <div className='save'>
                    { txtButton ? 
                        <h3 style={{ color: '#49FF00' }}>{txtButton}</h3> : 
                        null
                    }
                    <Button onClick={handleSubmit}>
                        Guardar preferencias
                    </Button>
                    
                </div>
            </div>
        </div>
    )
}

function getDataMode(prefs) {
    return prefs.map( pref => {
        return {
            ...pref.preferences_privacity
        }
    })
}

// Redux
const mapStateToProps = state => {

    const dataPrivacity = state.user.dataPrivacity;
    const dataUser = state.user.data;

    return {
        dataPrivacity,
        dataUser
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPreferencesPrivacity: () => dispatch(getPreferencesPrivacity()),
        getDataProfile: () => dispatch(getDataProfile()),
        updatePreferencesPrivacityOfUser: prefs => dispatch(updatePreferencesPrivacityOfUser(prefs))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Privacity))
